function getBrandConfigQueue(session_key) {
  return fetch(
    `${process.env.REACT_APP_API_ENDPOINT}/brand-configuration-queue`,
    {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        session_key: `${session_key}`,
      },
    }
  )
    .then((response) => response.json())
    .then((responseJSON) => {
      return responseJSON;
    });
}

export default getBrandConfigQueue;
